export enum NotificationScenario_Enum {
    CustomerQuote,
    DealerIntroQuote,
    NoteCreated,
    DealerNoteCreated,
    ApplicationStateChanged,
    UnableToContact,
    Dealt,
    Payout,
    CustomerValCall,
    DealerValCall,
    Proceeding,
    Dead,
    AsmDocsOut,
    DealerDocsOut,
    LenderDecision,
    ApplicationReceived,
    PaymentRequest,
    PaymentReceived,
    DealerPaymentReceived,
    EligibilityCheckReminder,
    DocumentSnagged,
    OrderSend,
    OrderComplete
}